import { Component, Input } from '@angular/core';
import { NgForOf } from '@angular/common';
import { Colorset, ColorsetTemplate } from '../../../models/colorset';

@Component({
  selector: 'app-colors',
  standalone: true,
  imports: [NgForOf],
  templateUrl: './colors.component.html',
  styleUrl: './colors.component.scss',
})
export class ColorsComponent {
  @Input() colorset!: Colorset | ColorsetTemplate;
}
